var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeverityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7916 11.9167C17.6891 11.9167 18.4166 11.1892 18.4166 10.2917C18.4166 9.39429 17.6891 8.66675 16.7916 8.66675C15.8942 8.66675 15.1666 9.39429 15.1666 10.2917C15.1666 11.1892 15.8942 11.9167 16.7916 11.9167Z",
    fill: "#1034A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20837 11.9167C10.1058 11.9167 10.8334 11.1892 10.8334 10.2917C10.8334 9.39429 10.1058 8.66675 9.20837 8.66675C8.31091 8.66675 7.58337 9.39429 7.58337 10.2917C7.58337 11.1892 8.31091 11.9167 9.20837 11.9167Z",
    fill: "#1034A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.1667C10.4758 15.1667 8.31996 16.7376 7.45329 18.9584H9.26246C10.01 17.6692 11.3966 16.7917 13 16.7917C14.6033 16.7917 15.9791 17.6692 16.7375 18.9584H18.5466C17.68 16.7376 15.5241 15.1667 13 15.1667ZM12.9891 2.16675C7.00913 2.16675 2.16663 7.02008 2.16663 13.0001C2.16663 18.9801 7.00913 23.8334 12.9891 23.8334C18.98 23.8334 23.8333 18.9801 23.8333 13.0001C23.8333 7.02008 18.98 2.16675 12.9891 2.16675ZM13 21.6667C8.21163 21.6667 4.33329 17.7884 4.33329 13.0001C4.33329 8.21175 8.21163 4.33341 13 4.33341C17.7883 4.33341 21.6666 8.21175 21.6666 13.0001C21.6666 17.7884 17.7883 21.6667 13 21.6667Z",
    fill: "#1034A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeverityIcon);
export default __webpack_public_path__ + "static/media/severity-icon.d9adc53a8470eea6c5dbd44b8fe04514.svg";
export { ForwardRef as ReactComponent };